import { Chip } from "@mui/material";

import {
  getChipColorForField
} from "../common/colors";
import { IndicatorFields } from "../types/artifact";

interface ColorChipProps {
  value: string | number | null | undefined;
  field: IndicatorFields;
  size?: "small" | "medium";
}

const ColorChip: React.FC<ColorChipProps> = ({ value, field, size = "small" }) => {
  let displayValue: string;

  if (value === null || value === undefined) {
    displayValue = "N/A";
  } else if (field === "score" && typeof value === "number") {
    displayValue = value.toFixed(2);
  } else {
    displayValue = String(value);
  }

  const chipColor = getChipColorForField(field, value);

  return (
    <Chip
      label={displayValue.toUpperCase()}
      size={size}
      sx={{
        pt: "2px",
        backgroundColor: chipColor.background,
        color: chipColor.fontColor,
        border: `1px solid ${chipColor.border}`,
        fontWeight: "medium",
        width: "100px",
        height: "24px",
        justifyContent: "center",
        "& .MuiChip-label": {
          textTransform: "uppercase"
        }
      }}
    />
  );
};

export default ColorChip;
